import * as React from 'react'
import { Spin, Form, Input } from 'antd'
import { isEmpty, get } from 'lodash'
import { useImmer } from 'use-immer'
import { showError } from 'helpers/errors'
import { createLabelFactory } from 'helpers/formViews'
import { stopEvent } from 'helpers/events'
import { Header, Title } from 'helpers/print'
import { t } from 'helpers/i18n'
import { formatUserTime } from 'helpers/dateTime'
import CycleCountItems from 'containers/CycleCounts/Print/Items'
import { Row, Col } from 'elements/Grid'

function Component(props) {
  const { parentRecord: item, tenant, getSettings, getDetailsSettings, getDocumentContents } = props

  const [state, updateState] = useImmer({})

  React.useEffect(() => {
    async function fetchSettings() {
      try {
        const responses = await Promise.all([
          getSettings(),
          getDetailsSettings(),
          getDocumentContents({
            request: {
              domainObjectId: tenant.id,
              domainObjectType: 'Customer',
              documentType: 'PurchaseOrderLogo',
              documentName: tenant.subdomain,
            },
          }).catch(() => {}),
        ])

        updateState((draft) => {
          draft.fieldSettings = responses[0].value.data.fieldSettings
          draft.detailsSettings = responses[1].value.data.fieldSettings
          draft.logo = get(responses[2], 'value.data', {})
        })
      } catch (error) {
        showError({ error })
      }
    }

    fetchSettings()
  }, [])

  const title = `${t('cycleCount')} - ${item.id}`
  const createLabel = createLabelFactory(state.fieldSettings)

  return isEmpty(state.fieldSettings) ? (
    <Spin />
  ) : (
    <>
      <Title>
        <Col xs={16}>
          <h2>{title}</h2>
        </Col>
        <Col xs={8} className="text-right">
          {state.logo && state.logo.fileType && state.logo.contents && (
            <img src={`data:${state.logo.fileType};base64,${state.logo.contents}`} alt="" />
          )}
        </Col>
      </Title>
      <Header className="mb-24">
        <Form layout="vertical" colon={false} onSubmit={stopEvent}>
          <Row>
            <Col xs={4}>
              <Form.Item label={createLabel('locationName')}>
                <Input value={item.locationName} disabled />
              </Form.Item>
            </Col>
            <Col xs={4}>
              <Form.Item label={createLabel('typeDescription')}>
                <Input value={item.typeDescription} disabled />
              </Form.Item>
            </Col>
            <Col xs={4}>
              <Form.Item label={createLabel('statusDescription')}>
                <Input value={item.statusDescription} disabled />
              </Form.Item>
            </Col>
            <Col xs={4}>
              <Form.Item label={createLabel('itemsAtLocation')}>
                <Input value={item.itemsAtLocation} disabled />
              </Form.Item>
            </Col>
            <Col xs={4}>
              <Form.Item label={createLabel('itemsOnCount')}>
                <Input value={item.itemsOnCount} disabled />
              </Form.Item>
            </Col>
            <Col xs={4}>
              <Form.Item label={t('created')}>
                <Input value={formatUserTime(item.createdDate, item.createdBy)} disabled />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Header>
      {!isEmpty(item.detailItems) && (
        <CycleCountItems
          storageKey="cycleCounts.formView.details"
          fieldSettings={state.detailsSettings}
          items={item.detailItems}
          parentRecord={item}
        />
      )}
    </>
  )
}

export default Component
